import Vue from 'vue';
import Donation from './donation.vue';
Vue.component('donation', Donation);
